import React from 'react';
import {StyleSheet, View} from 'react-native';

import LoadingImg from '../components/LoadingImg';
import theme from '../style/theme';

const SplashScreen = () => (
  <View style={[styles.container, StyleSheet.absoluteFill]}>
    <View style={[styles.primaryWaitingContainer, StyleSheet.absoluteFill]}>
      <LoadingImg />
    </View>
  </View>
);

export default SplashScreen;

const styles = StyleSheet.create({
  primaryWaitingContainer: {
    flex: 1,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colour.background.general.primary,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderWidth: 2,
  },
});
